import React from "react";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    //paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "centers",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appToolbar: {
    [theme.breakpoints.up("sm")]: {
      alignItems: "center",
      width: "100%",
      background: theme.primary,
      //marginLeft: "15%",
      //width: `calc(100% - ${DrawerWidth}px)`,
      //marginLeft: DrawerWidth,
    },
  },
  nestedAppToolbar: {
    [theme.breakpoints.up("sm")]: {
      alignItems: "center",
      color: "white",
      width: "50%",
      marginLeft: "25%",
      marginRight: "25%",
      background: "#3374b2",
      //width: `calc(100% - ${DrawerWidth}px)`,
      //marginLeft: DrawerWidth,
    },
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,
  },
  tacticContainer: {
    justifyContent: "center",
    alignItems: "center",
    direction: "row",
    spacing: 2,
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    //width: "100%",
  },
  fixedHeight: {
    height: 300,
  },
  balanceCard: {
    height: 400,
    //width: "100%",
    //width: 500,
  },
  column: {
    flexBasis: "33%",
  },
}));

function GeneralTips(props) {
  const classes = useStyles();
  const isPrintout = props.printout;
  const balancePaper = clsx(classes.paper, classes.balanceCard);
  const sections = [
    "Using Multiple Acquisition Pathways",
    "Acquisition Planning",
    "Documentation",
    "Technology & Design",
    "Stakeholder Management",
    "Funding",
    "General Resources",
    "Sole Source Resources",
    "UCA Resources",
    "Critical Path Resources",
  ];
  const printoutSections = [
    "Using Multiple Acquisition Pathways",
    "Acquisition Planning",
    "Documentation",
    "Technology & Design",
    "Stakeholder Management",
    "Funding",
  ];

  let getPrimary = (text) => {
    return text[0].substring(0, text[0].indexOf("."));
  };

  let getSecondary = (text) => {
    return text[0].substring(text[0].indexOf(".") + 1);
  };

  const generalTipsDict = props.currentContext.getGeneralTips();
  const getPrintoutResources = () => {
    if (props.currentContext.pathwayChoice === "UCA") {
      return [
        "General Resources",
        "Sole Source Resources",
        "UCA Resources",
        "Critical Path Resources",
      ];
    } else {
      return ["General Resources"];
    }
  };

  return (
    <>
      {isPrintout ? (
        <>
          {printoutSections.map((elem) => (
            <div>
              <Paper>
                <Grid
                  item
                  xs={12}
                  justify="center"
                  spacing={1}
                  style={{ alignItems: "flex-start", textAlign: "center" }}
                >
                  <b>{elem}</b>
                </Grid>
                <Grid container item xs={12} zeroMinWidth>
                  <List>
                    {generalTipsDict[elem].map((subelem) => (
                      <ListItem key={generalTipsDict[elem].indexOf(subelem)}>
                        <ListItemText
                          primaryTypographyProps={{ textAlign: "center" }}
                          primary={getPrimary(subelem)}
                          secondary={getSecondary(subelem)}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Grid>
              </Paper>
              {elem !== "Technology & Design" && <div class="pagebreak" />}
            </div>
          ))}
          {generalTipsDict["General Resources"].length !== 0 && (
            <Grid container xs={12} spacing={3}>
              {getPrintoutResources().map((elem) => (
                <Grid item xs={5}>
                  <Paper>
                    <Grid
                      item
                      xs={12}
                      justify="center"
                      spacing={1}
                      style={{ alignItems: "flex-start", textAlign: "center" }}
                    >
                      <b>{elem}</b>
                    </Grid>
                    <Grid item xs={12} zeroMinWidth>
                      <List>
                        {generalTipsDict[elem].map((subelem) => (
                          <ListItem
                            key={generalTipsDict[elem].indexOf(subelem)}
                          >
                            <div
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "100%",
                              }}
                            >
                              <Typography noWrap>
                                <a href={subelem} target="_blank>">
                                  {subelem}
                                </a>
                              </Typography>
                            </div>
                          </ListItem>
                        ))}
                      </List>
                    </Grid>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          )}
          {<div class="pagebreak" />}
        </>
      ) : (
        <>
          <Grid container>
            {sections.map((elem) => (
              <Grid
                item
                xs={6}
                justify="center"
                spacing={1}
                style={{ alignItems: "flex-start", textAlign: "center" }}
              >
                <Grid item xs={12} style={{ textAlign: "center" }}>
                  <b>{elem}</b>
                </Grid>
                <Grid
                  container
                  style={{ textAlign: "center" }}
                  item
                  xs={12}
                  zeroMinWidth
                >
                  <List>
                    {generalTipsDict[elem].map((subelem) => (
                      <Grid item xs={12}>
                        <ListItem key={generalTipsDict[elem].indexOf(subelem)}>
                          {elem.includes("Resource") ? (
                            <div
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                maxWidth: "50%",
                              }}
                            >
                              <Typography noWrap>
                                <a href={subelem} target="_blank>">
                                  {subelem}
                                </a>
                              </Typography>
                            </div>
                          ) : (
                            <ListItemText
                              primary={getPrimary(subelem)}
                              secondary={getSecondary(subelem)}
                            />
                          )}
                        </ListItem>
                      </Grid>
                    ))}
                  </List>
                </Grid>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </>
  );
}

export default GeneralTips;
